<template>
   <div>
        <div v-if="loading" class="ui active bottom attached tab segment">
            <div class="ui active centered inline loader"></div><br>
            <div style='width:100%;text-align:center'>Loading...</div>
        </div>
        <div v-if="floor_selector" class="ui top attached tabular menu">
            <div class="item" v-bind:class="{active:active_floor=='ground_floor'}" v-on:click="loadPlan('ground_floor')" style="cursor:pointer">Ground Floor</div>
            <div class="item" v-bind:class="{active:active_floor=='first_floor'}" v-on:click="loadPlan('first_floor')" style="cursor:pointer">First Floor</div>
            <div class="item" v-bind:class="{active:active_floor=='second_floor'}" v-on:click="loadPlan('second_floor')" style="cursor:pointer">Second Floor</div>
            <div class="right menu">
                <div class="ui dropdown scrolling item" id="room_selector">
                    Room
                    <i class="dropdown icon"></i>
                    <div class="menu">
                        <div v-for="room in room_list" :key="room.id" class="item" v-on:click=" loadRoomImages(room.id)" v-bind:class="{disabled:!room.in_plan}">{{room.id}} {{room.label}}</div>
                    </div>
                </div>
                <div class="ui dropdown scrolling item" id="place_selector" style="display:none">
                    Place
                    <i class="dropdown icon"></i>
                    <div class="menu">
                        <div v-for="place in place_list" :key="place.id" class="item" v-on:click="loadRoomImages('', place.id)">{{place.id}} {{place.label}}</div>
                    </div>
                </div>
             <!--   <div class="ui item" v-on:click="$emit('changePlanLeyout')" style="cursor:pointer">
                     <i class="expand arrows alternate icon"></i>
                </div>-->
                
            </div>
           
            
        </div>
        <div class="ui bottom attached active tab segment">
            <div v-if="!loading" v-html="svg" id="svg_wraper" v-bind:class="{extended:extended}"></div>
            <div v-if="room_label!=''" class="room_label" v-bind:class="{cursor_pointer:!clickable}" v-on:click="searchRoom(room_id_inner)">
                <h4>{{room_label}}</h4>
            </div>
            <div v-if="!loading" class="control">
                <i v-if="debug" class="map pin icon" style="cursor:pointer" v-on:click="showPan()"></i>
                <span v-if="debug" id="coordinates"></span>
                <div :data-tooltip="tooltip('Room detail')" style=" float:left; "><i v-if="active_room!=0" class="compress large icon" style="cursor:pointer" v-on:click="zoomRoom(active_room)"></i></div>
                <div :data-tooltip="tooltip('Overall plan')" style=" float:left; "><i class="expand large icon" style="cursor:pointer" v-on:click="reset()"></i></div>
                <div :data-tooltip="tooltip('Zoom In')" style=" float:left; "><i class="plus square outline large icon" style="cursor:pointer" v-on:click="zoomIn()"></i></div>
                <div :data-tooltip="tooltip('Zoom Out')" style=" float:left; "><i class="minus square outline large icon" style="cursor:pointer" v-on:click="zoomOut()"></i></div>
                <div :data-tooltip="tooltip('Enlarged View')" style=" float:left; "><i v-if="!extended && !floor_selector" class="expand arrows alternate large icon" style="cursor:pointer" v-on:click="$emit('openExtendedPlan');"></i></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['room_id', 'extended', 'floor_selector', 'debug', 'clickable'],
        data() {
            return {
                active_room: 0,
                active_floor: "",
                svg: "",
                room_data: {},
                castle_plan: null,
                loading: true,
                room_data_loaded: false,
                room_label: "",
                allRoomData: null,
                room_id_inner: this.room_id,
                showTooltip: true,
                room_list: null,
                place_list: null
                // room_id:""

            }
        },
        methods: {
            tooltip: function(str) {
                if (this.showTooltip) return str;
            },
            showPan: function() {
                this.setGlobalCastelPlan();
                var kx = this.castle_plan.getPan().x / this.castle_plan.getSizes().width;
                var ky = this.castle_plan.getPan().y / this.castle_plan.getSizes().height;
                var z = this.castle_plan.getZoom();
                $('#coordinates').html(kx.toFixed(3) + "," + ky.toFixed(3) + "," + z.toFixed(3) + "&nbsp;&nbsp;&nbsp;")
            },
            setGlobalCastelPlan: function() {
                if (this.castle_plan == null) {
                    this.castle_plan = svgPanZoom('#castle_plan');
                }
            },
            zoomIn: function() {
                this.setGlobalCastelPlan();
                this.castle_plan.zoomIn();
            },
            zoomOut: function() {
                this.setGlobalCastelPlan();
                this.castle_plan.zoomOut();
            },
            reset: function() {
                this.setGlobalCastelPlan();
                this.castle_plan.reset();
                if (this.active_room != 0) {
                    // document.getElementById('room_' + this.active_room).style.display = 'block';
                    //  document.getElementById('room_' + this.active_room).style.fill = "#B9DBF8"
                }
            },
            zoomRoom: function(room_id) {
                this.setGlobalCastelPlan();
                this.castle_plan.zoom(this.room_data['room_' + this.active_room].z);
                var x = this.castle_plan.getSizes().width * this.room_data['room_' + this.active_room].kx;
                var y = this.castle_plan.getSizes().height * this.room_data['room_' + this.active_room].ky;
                this.castle_plan.pan({ x: x, y: y });
                if (this.active_room != 0) {
                    //  document.getElementById('room_' + this.active_room).style.display = 'none';
                    //      document.getElementById('room_' + this.active_room).style.fill = "#FFFFFF"
                }
            },
            loadPlan: function(floor, room_id) {
                // var floors = ['ground_floor', 'first_floor', 'second_floor'];

                if (room_id == undefined) {
                    this.active_room = 0;
                    this.$emit('loadImages', 0);
                }

                this.active_floor = floor;
                this.castle_plan = null
                this.logging = true;
                this.room_label = ""
                var localThis = this;
                axios
                    .get('/api/downloads/' + floor)
                    .then(response => {
                        this.svg = response.data;
                        this.loading = false;
                        setTimeout(function() {
                            localThis.createActiveObejctinFloor(floor);
                            var castle_plan = svgPanZoom('#castle_plan', {
                                zoomEnabled: true,
                                controlIconsEnabled: false,
                                fit: true,
                                minZoom: 1,
                                maxZoom: 20,
                                center: true,
                                beforePan: beforePan,
                            });
                            $('#castle_plan').css("height", Math.round(castle_plan.getSizes().width * 0.827) + "px");
                            if (room_id != undefined) {
                                document.getElementById('room' + room_id).style.fill = "#B9DBF8";
                                if (!localThis.clickable) {
                                    localThis.zoomRoom();
                                }

                            }
                        }, 200);

                        var beforePan = function(oldPan, newPan) {
                            var stopHorizontal = false,
                                stopVertical = false,
                                gutterWidth = 400,
                                gutterHeight = 400,
                                sizes = this.getSizes(),
                                leftLimit = -((sizes.viewBox.x + sizes.viewBox.width) * sizes.realZoom) + gutterWidth,
                                rightLimit = sizes.width - gutterWidth - (sizes.viewBox.x * sizes.realZoom),
                                topLimit = -((sizes.viewBox.y + sizes.viewBox.height) * sizes.realZoom) + gutterHeight,
                                bottomLimit = sizes.height - gutterHeight - (sizes.viewBox.y * sizes.realZoom)
                            var customPan = {}
                            customPan.x = Math.max(leftLimit, Math.min(rightLimit, newPan.x))
                            customPan.y = Math.max(topLimit, Math.min(bottomLimit, newPan.y))
                            return customPan;
                        }
                    });
            },
            searchRoom: function(room_id) {
                if (!this.clickable) {
                    this.$router.push({ name: 'advancedsearch', query: { room: room_id } })
                }
            },

            displayRoom: function(room_data) {
                if (room_data.floor != this.active_floor) {
                    this.loadPlan(room_data.floor, room_data.id);
                    this.active_room = room_data.id;
                    //  document.getElementById(this.active_room).style.fill = "#B9DBF8";
                }
                else {
                    if (this.clickable) {
                        if (this.active_room != 0) {
                            document.getElementById('room' + this.active_room).style.fill = "#FFFFFF"
                        }
                        this.active_room = room_data.id
                        document.getElementById('room' + this.active_room).style.fill = "#B9DBF8";
                    }
                }
                this.room_label = room_data.id + " – " + room_data.label;
            },

            loadAllRoomData: function() {
                axios
                    .get('/api/plan/all')
                    .then(response => {
                        for (var i in response.data) {
                            this.room_data['room_' + response.data[i].id] = response.data[i];
                        }
                        this.allRoomData = response.data;
                        /*     setTimeout(function() {
                                 $('#room_selector').dropdown();
                             }, 200)*/
                        this.room_data_loaded = true;
                    });
            },
            loadRoomList: function() {
                axios
                    .get('/api/plan/list')
                    .then(response => {
                        this.room_list = response.data;
                        setTimeout(function() {
                            $('#room_selector').dropdown();
                        }, 200)
                    })
            },

            addActiveObject: function(room_data) {
                var localThis = this;
                var svg = document.getElementById('castle_plan') //Get svg element
                var newElement = document.createElementNS("http://www.w3.org/2000/svg", 'path'); //Create a path in SVG's namespace
                newElement.setAttribute("d", room_data.svg_path); //Set path's data
                newElement.style.stroke = "#000"; //Set stroke colour
                newElement.style.strokeWidth = "0.25px"; //Set stroke width
                newElement.style.fill = "#FFFFFF";
                if (this.clickable) {
                    newElement.style.cursor = "pointer";
                    newElement.onmouseover = function() {
                        this.style.fill = "#B9DBF8";
                    }
                    newElement.onmouseout = function() {
                        if (this.id != ('room' + localThis.active_room))
                            this.style.fill = "#FFFFFF";
                    }
                    newElement.onclick = function() {
                        localThis.loadRoomImages(room_data.id);
                    }
                }
                newElement.setAttribute('id', 'room' + room_data.id);
                newElement.setAttribute('name', 'room' + room_data.id);
                svg.insertBefore(newElement, svg.childNodes[0]);


            },

            addNumber: function(room_data) {
                var localThis = this;
                var svg = document.getElementById('castle_plan') //Get svg element
                var newElement = document.createElementNS("http://www.w3.org/2000/svg", 'text'); //Create a text in SVG's namespace
                //<text x="1597.23" y="1133.42" font-family="'TimesNewRomanPS-ItalicMT','Times New Roman',serif" font-style="italic" font-size="6.552" fill="red" transform="translate(-1044.46 -1088.65)">10</text>
                //<text x="2566.6" y="1342.4" font-family="'TimesNewRomanPS-ItalicMT','Times New Roman',serif" font-style="italic" font-size="6.552" fill="red" transform="translate(-2088.7 -1088.58)">6</text>
                newElement.setAttribute("x", room_data.number_x); //Set path's data
                newElement.setAttribute("y", room_data.number_y); //Set path's data
                newElement.setAttribute("class", "room_number");
                newElement.setAttribute("font-family", "TimesNewRomanPS-ItalicMT','Times New Roman',serif");
                newElement.setAttribute("font-style", "italic");
                newElement.setAttribute("font-size", "6.6");
                newElement.setAttribute("fill", "red");
                newElement.style.cursor = "default";
                newElement.innerHTML = room_data.id;
                if (room_data.floor == "first_floor") {
                    newElement.setAttribute("transform", "translate(-1044.46 -1088.65)")
                }
                if (room_data.floor == "second_floor") {
                    newElement.setAttribute("transform", "translate(-2088.7 -1088.58)")
                }

                if (this.clickable) {
                    newElement.style.cursor = "pointer";
                    newElement.onclick = function() {
                        localThis.loadRoomImages(room_data.id);
                    }
                    newElement.onmouseover = function() {
                        document.getElementById('room' + room_data.id).style.fill = "#B9DBF8";
                    }
                    newElement.onmouseout = function() {
                        if (this.id != ('room_number' + localThis.active_room))
                            document.getElementById('room' + room_data.id).style.fill = "#FFFFFF";
                    }
                }
                newElement.setAttribute('id', 'room_number' + room_data.id);
                newElement.setAttribute('name', 'room_number' + room_data.id);
                svg.appendChild(newElement, svg.childNodes[0])
            },

            createActiveObejctinFloor: function(floor) {

                for (var i in this.allRoomData) {
                    if (this.allRoomData[i].floor == floor && this.allRoomData[i].in_plan) {
                        this.addNumber(this.allRoomData[i]);
                        this.addActiveObject(this.allRoomData[i]);
                    }
                }

            },

            loadRoomImages: function(room_id, place_id) {
                this.room_id_inner = room_id;
                if (place_id == undefined) {
                    this.place_list = null;
                    
                    for (var i in this.room_list) {
                        if (this.room_list[i].id == room_id) {
                            this.room_label = this.room_list[i].id + " – " + this.room_list[i].label;
                         //   console.log(this.room_list[i].id + " – " + this.room_list[i].label);
                            if (this.room_list[i].hasOwnProperty('places')) {
                                this.place_list = this.room_list[i].places;
                            }
                            break;
                        }
                    }
                    if (this.place_list != null) {
                        $('#place_selector').css('display', 'block')
                        $('#place_selector').dropdown('clear');
                    }
                    else {
                        $('#place_selector').css('display', 'none')
                    }
                    this.$emit('loadImages', room_id);

                }
                else {
                    for (var i in this.room_list) {
                        if (this.room_list[i].id == this.active_room) {
                            for (var j in this.place_list) {
                                if (this.place_list[j].id == place_id) {
                                    this.room_label = this.room_list[i].id + " – " + this.room_list[i].label+" – "+this.place_list[j].label;
                                 //   console.log( this.room_label = this.room_list[i].id + " – " + this.room_list[i].label+" – "+this.place_list[j].label);
                                }
                            }
                        }
                    }
                    this.$emit('loadImages', this.active_room, place_id);
                }

            }

        },
        beforeMount() {
            this.loadAllRoomData();

        },
        mounted() {
            if (this.room_id_inner == undefined || this.room_id_inner == 0) {
                this.loadPlan("first_floor");
            }
            this.loadRoomList()

        },
        watch: {
            room_id_inner(to, from) {
                for (var i in this.allRoomData) {
                    if (this.allRoomData[i].id == to) {
                        this.displayRoom(this.allRoomData[i]);
                        break;
                    }
                }

            },
            room_data_loaded(to, from) {
                if (to == true && this.room_id_inner != undefined && this.room_id_inner != 0) {
                    for (var i in this.allRoomData) {
                        if (this.allRoomData[i].id == this.room_id_inner) {
                            this.displayRoom(this.allRoomData[i]);
                            break;
                        }
                    }
                }
            }

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .control {
        position: absolute;
        right: 20px;
        bottom: 20px;
        border: 1px solid rgb(212, 212, 212);
        border-radius: 5px;
        background: rgba(255, 255, 255, 0.9);
        padding: 5px 5px;
    }

    .beta-version {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 80px;
    }

    .floor {
        border: 2px solid black;
        border-radius: 2px;
        line-height: 1;
        vertical-align: middle;
        font-size: 1em;
        width: 1.5em;
        text-align: center;
        padding: 1px 0px 1px 0px;
    }

    .super {
        vertical-align: top;
        font-size: 0.5em;
    }

    .active_floor {
        color: white;
        background-color: #000000;
    }

    .cursor_pointer {
        cursor: pointer;
    }

    .room_label {
        position: absolute;
        top: 20px;
        left: 20px;
        border: 1px solid rgb(212, 212, 212);
        border-radius: 5px;
        background: rgba(255, 255, 255, 0.7);
        padding: 5px 5px;

    }
    .extended{
        width:40vw;
    }
</style>



// WEBPACK FOOTER //
// src/components/ThePlanView.vue